import {InjectionToken} from '@angular/core';
import type {Observable} from 'rxjs';
import type {
  ContactGroup,
  ContactGroupListQuery,
  ContactGroupListResult,
  CreateContactGroupPayload,
} from '../types/contacts.types';

export interface ContactsGroupsApi {
  listGroups(query?: ContactGroupListQuery): Observable<ContactGroupListResult>;
  createGroup(payload: CreateContactGroupPayload): Observable<ContactGroup>;
  updateGroup(groupId: string, name: string): Observable<void>;
  deleteGroup(groupId: string): Observable<void>;
}

export const CONTACTS_GROUPS_API = new InjectionToken<ContactsGroupsApi>('CONTACTS_GROUPS_API');
